/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import { StorageModule } from '@vlinder-web/storage-module-react';

import { useOrgId } from '../provider';
import { apiConfig } from '@/config/apiConfig';
import { INVITE_ORG_ADMIN } from '../../api/graphql';
import moment from 'moment-timezone';
import { vappContainer } from '@/application';
import { Graphql } from '@common/graphql';
import { AppNavigatorService } from '@/AppNavigator/services';

const getStorageSrv = StorageModule?.getInstance();

const loginSrv = () => {
  return vappContainer.get<AppNavigatorService>(
    AppNavigatorService.displayName
  );
};

export interface InviteUserProps {
  email: string;
  firstName: string;
  lastName: string;
  invite: boolean;
  userRoles: boolean;
  loginRestAPI: string;
  headers: any;
  termsOfUse: any;
}
export interface IInviteUserMethods extends IPluginMethodMap {
  getInviteUser(args: InviteUserProps): Promise<any>;
}

export class InviteUserService implements IAgentPlugin {
  readonly methods: IInviteUserMethods;

  constructor() {
    this.methods = {
      getInviteUser: this.getInviteUser.bind(this),
    };
  }

  async getInviteUser(args: InviteUserProps) {
    console.log(`args in invite user service `, args);
    try {
      let gql = Graphql.withBaseUrl(apiConfig.gql.url);
      const token = loginSrv()?.getToken();
      if (token) {
        gql = gql.withHeaders({
          authentication: token,
        });
      }
      const client = gql.getClient();
      if (client) {
        const res = await client.mutation(INVITE_ORG_ADMIN, {
          input: {
            // invite: args?.sendInvite
            //   ? args?.sendInvite[0] === 'yes'
            //     ? true
            //     : false
            //   : false,
            invite: true,
            user: {
              firstName: args?.firstName,
              lastName: args?.lastName,
              email: args?.email,
            },
            // org: this.getOrgnizationId(),
            // role: await this.getRole(args?.userRoles),
            role: 'admin',
          },
        });
        if (res?.data?.createUser) {
          console.log(`table data`, res);
          return {
            ...res?.data,
          };
        }
      }
    } catch (err: any) {
      let _display_message =
        err?.graphQLErrors &&
        Array.isArray(err?.graphQLErrors) &&
        err?.graphQLErrors.find((item: any) => item.extensions);
      if (_display_message?.extensions?.display_message) {
        throw Error(_display_message?.extensions?.display_message);
      }

      throw err;
    }
  }

  private getOrgnizationId() {
    let orgId = getStorageSrv?.get('myProfile', 'session')?.org?.orgId;
    return orgId;
  }

  private async getRole(roles: any) {
    console.log(`roles:`, roles);
    let adminRole =
      Array.isArray(roles) && roles?.find((item) => item?.name === 'admin');
    console.log(`admin Role`, adminRole);
    return adminRole?.uuid;
    // const user = await getWhoamiSrv()?.whoAmI();
    // if(user?.whoami === "RISK_CAPITAL"){
    //   return null
    // }
    // else{
    //   return null
    // }
  }
}
